import '../css/login.css';
import '../css/index.css';
import logo from '../img/logo-softmining.svg';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const { resetPassword } = useAuth();
    const navigate = useNavigate();

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");
        try {
            await resetPassword(email);
            setMessage("Se l’email esiste, hai ricevuto un link per il reset.");
            // opzionale: dopo qualche secondo torna al login
            setTimeout(() => navigate("/login"), 3000);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="form-container">
            <div className="form formLogin">
                <img src={logo} className="sign-logo" alt="logo" />
                <form onSubmit={handleResetPassword}>
                    <label className="selectLabel">Enter your e-mail account to send the reset password request</label>
                    <label className="text" htmlFor="email">E-mail</label>
                    <input
                        type="email"
                        id="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email..."
                    />
                    {message && <p className="success-message">{message}</p>}
                    {error && <p className="error-message">{error}</p>}

                    <button type="submit" className="sign-button button">Send request</button>
                </form>
                <div className="footer-form">
                    <div className="divleftFooterForm">
                        <Link className="textlink textLinkSign" to="/signup">Sign up</Link>
                    </div>
                    <div className="divrightFooterForm">
                        <Link className="textlink textLinkSign" to="/login">Back to Login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
